// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ms-0";
export var assigneeDetails = "_ms-1";
export var assigneeInfo = "_ms-2";
export var dropdownContainer = "_ms-4";
export var dropdownImage = "_ms-5";
export var editAssigneeInfo = "_ms-3";
export var editAssigneeModalContainer = "_ms-6";
export var hidden = "_ms-8";
export var input = "_ms-7";